export default __webpack_public_path__ + "static/splash-2712dba9beead251b0498cc4ac6b806d.svg";